<template>
  <div id="appraisal-process-history" class="card-item history-visible">
    <AppraisalHistoryFilter
      id="appraisals-filter"
      v-on="$listeners" />
    <AppraisalHistoryList
      id="appraisals-list"
      :appraisal-list="appraisalList" />
  </div>
</template>

<script>
import AppraisalHistoryFilter from '@/ui/views/internal/trading/AppraisalHistoryFilter.vue';
import AppraisalHistoryList from '@/ui/views/internal/trading/AppraisalHistoryList.vue';

export default {
  name: 'AppraisalHistory',
  components: { AppraisalHistoryList, AppraisalHistoryFilter },
  props: {
    appraisalList: {
      type: Array,
      required: true,
      default: () => { return []; }
    }
  },
  data() {
    return {
      filtroEstado: 'Todos',
      filtroCliente: '',
      filtroTipoVenta: '',
      filtroUsuario: 'Todos'
    };
  }
};
</script>

<style scoped>
.history-visible {
  overflow: visible !important;
}
</style>
